import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  OccupationListHighGrowthGQL,
  OccupationListMilitaryFriendlyGQL,
  GetOccupationListByCountyGQL,
  GetOccupationListByDegreeGQL,
  CpdOccupation as GraphQLOccupation
} from '@cpd-app/generated';

import {
  OccupationQuickMatchModel,
  LocationModel,
  MajorModel
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class OccupationMicroService {
  constructor(
    private occupationListHighGrowthGQL: OccupationListHighGrowthGQL,
    private occupationListMilitaryFriendlyGQL: OccupationListMilitaryFriendlyGQL,
    private getOccupationListByCountyGQL: GetOccupationListByCountyGQL,
    private getOccupationListByDegreeGQL: GetOccupationListByDegreeGQL
  ) {}

  public getOccupationListByLocation(
    locationModel: LocationModel
  ): Observable<OccupationQuickMatchModel[]> {
    return this.getOccupationListByCountyGQL
      .fetch({
        param: locationModel.countyFIPSCode.toString()
      })
      .pipe(
        map((results) =>
          this.transformOccupationQuickMatchList(
            results?.data?.getOccupationList,
            false
          )
        )
      );
  }

  public getOccupationListByMajor(
    majorModel: MajorModel
  ): Observable<OccupationQuickMatchModel[]> {
    return this.getOccupationListByDegreeGQL
      .fetch({
        param: majorModel.CipCode
      })
      .pipe(
        map((results) =>
          this.transformOccupationQuickMatchList(
            results?.data?.getOccupationList,
            false
          )
        )
      );
  }

  public getOccupationListByDemand(): Observable<OccupationQuickMatchModel[]> {
    return this.occupationListHighGrowthGQL
      .fetch()
      .pipe(
        map((results) =>
          this.transformOccupationQuickMatchList(
            results?.data?.getOccupationList,
            false
          )
        )
      );
  }

  public getMilitaryFrienldyOccupationsList(): Observable<
    OccupationQuickMatchModel[]
  > {
    return this.occupationListMilitaryFriendlyGQL
      .fetch()
      .pipe(
        map((results) =>
          this.transformOccupationQuickMatchList(
            results?.data?.getOccupationList,
            true
          )
        )
      );
  }

  private transformOccupationQuickMatchList(
    rawJson: any,
    isMilitaryFriendlyOccupation: boolean
  ): OccupationQuickMatchModel[] {
    const list: OccupationQuickMatchModel[] = [];

    if (rawJson) {
      rawJson.map((item: GraphQLOccupation) => {
        const occQuickMatchModel = {
          onetCode: item.onetCode,
          title: item.title,
          projectedGrowth: item.projectedGrowth,
          growthRateBand: item.growthRateBand,
          militaryOccupationCount: item.militaryOccupationCount,
          annualWageLower: item.annualWageLower,
          annualWageHighest: item.annualWageHighest,
          medianAnnualWage: item.medianAnnualWage,
          imageName: item.imageName,
          videoId: item.videoId,
          videoUrl: item.videoUrl,
          isFavorite: false,
          isMilitaryFriendlyOccupation: isMilitaryFriendlyOccupation
        };
        list.push(occQuickMatchModel);
      });
    }
    return list;
  }
}
